PJQ.views.drawings.Dashboard = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard'),
        view: 'grid',
        mode: PJQ.constants.drawings.dashboardModes.VIEW,
        subTemplates: {
            versionGrid: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard-Version-Grid'),
            versionList: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard-Version-List'),
            versionStats: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard-Version-Stats'),
            versionSelect: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Viewer-Version-Selector'),
            emptyState: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard-Empty-State')
        },
        isReadOnly: false
    },
    events: {
        'click .btn-share-drawings': 'shareDrawings',
        'click .btn-download-all-split': 'downloadAllSplit',
        'click .btn-download-all-merged': 'downloadAllMerged',
        'click .btn-download-version-split': 'downloadContextVersionSplit',
        'click .btn-download-version-merged': 'downloadContextVersionMerged',
        'click .btn-download-filtered-split': 'downloadFilteredSplit',
        'click .btn-download-filtered-merged': 'downloadFilteredMerged',
        'click .btn-download-advanced': 'downloadAdvanced',
        'click .btn-export-drawing-list': 'exportDrawingList',
        'click .btn-order-version': 'orderContextVersion',
        'click .btn-order-filtered': 'orderFiltered',
        'click .btn-order-advanced': 'orderAdvanced',
        'click .btn-bulk-tag': 'bulkTag',
        'click .btn-sort-version': 'sortVersion',
        'click .btn-save-version': 'saveVersion',
        'click .btn-edit-version': 'editVersion',
        'keyup .input-drawing-name': 'drawingNameChanged',
        'keyup .input-drawing-title': 'drawingTitleChanged',
        'click .btn-cancel-edit-version': 'cancelEditVersion',
        'click .btn-new-batch': 'newBatch',
        'click .version-drawing-outer': 'drawingClicked',
        'click .version-select': 'versionSelected',
        'click .btn-manage-versions': 'manageVersions',
        'click .btn-upload-log': 'viewUploadLog',
        'keyup .input-drawings-search': 'renderContextVersion',
        'click .btn-view-grid': 'renderViewGrid',
        'click .btn-view-list': 'renderViewList',
        'click .btn-delete-drawing': 'deleteDrawing',
        'click .btn-drawing-rotate-90': 'rotateBatchDrawing90Clicked',
        'click .btn-drawing-rotate-180': 'rotateBatchDrawing180Clicked',
        'click .btn-drawing-rotate-270': 'rotateBatchDrawing270Clicked',
    },
    contextVersion: null,
    beforeFirstRender: function () {
        this.options.canEdit = PJQ.app.session.project != null
            && PJQ.app.session.project.hasPermission('drawings.isAdmin')
            && (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId'));
        if (PJQ.app.session.user == null || (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK_COMPANY) && PJQ.app.session.user.id !== 81732 &&
            !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK))) {
            this.options.canEdit = false;
        }
        this.options.canShare = PJQ.app.session.project != null
            && PJQ.app.session.project.hasPermission('drawings.canShare')
            && (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId'))
            && (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_SHARE_PEI)) &&
            (this.options.orderSettings == null || (this.options.orderSettings.get('downloadPerFileFee') === 0 || !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_ADMIN_PAID_DOWNLOADS)));

        this.options.canDownload = true;
        this.options.isPaidDownload = false;
        this.options.canOrder = !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_ORDER_PRINT);

        if (!this.options.orderSettings && PJQ.app.session.project && PJQ.app.session.project.orderSettings)
            this.options.orderSettings = PJQ.app.session.project.orderSettings;

        if (this.options.orderSettings && PJQ.app.session.project != null && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {
            this.options.canDownload = this.options.orderSettings.get('downloadPerFileFee') === 0 || PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId');
            this.options.isPaidDownload = !(this.options.orderSettings.get('downloadPerFileFee') === 0 || (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_ADMIN_PAID_DOWNLOADS)));
        }

        if (this.options.isReadOnly) {
            this.options.canEdit = false;
            this.options.canShare = false;
        }

        if (this.options.project != null) {
            this.options.hideIssuedOn = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_VERSION_SELECTOR_ISSUED_ON);
        } else {
            this.options.hideIssuedOn = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_VERSION_SELECTOR_ISSUED_ON);
        }

        let fetchCallback = _.bind(function () {
            this.listenTo(this.collection, 'update', _.bind(function () {
                this.render();
            }, this));
            // set the context version to current set if it has drawings
            if (this.options.project != null && this.options.canEdit) {
                PJQ.helpers.drawings.getUnPublishedBatchesCount(this.options.project.id, _.bind(function (batchCount) {
                    this.unPublishedBatchCount = batchCount;
                    this.render();
                }, this));
            } else {
                this.render();
            }
        }, this);
        if (this.collection == null) {
            this.options.project.fetchVersions(_.bind(function (versions) {
                this.collection = versions;
                fetchCallback();
            }, this));
        } else {
            fetchCallback();
        }
    },
    beforeRender: function () {
        if (this.collection != null) {
            if (this.contextVersion == null && this.options.initOptions?.versionId > 0) {
                let mVersionId = parseInt(this.options.initOptions.versionId);
                this.contextVersion = _.find(this.collection.models, (version) => {
                    return version.id === mVersionId;
                });
                console.log({
                    versionId: this.options.initOptions.versionId,
                    contextVersion: this.contextVersion
                });
            } else if (this.contextVersion == null) {
                this.contextVersion = _.find(this.collection.models, (version) => {
                    return version.id === -1;
                });
            }

            if (this.contextVersion != null && _.size(this.contextVersion.drawings.models) === 0 && _.size(this.collection.models) > 0) {
                this.contextVersion = this.contextVersion = _.find(this.collection.models, function (version) {
                    return _.size(version.drawings.models) > 0;
                });
            }

            if (this.contextVersion == null && _.size(this.collection.models) > 0) {
                this.contextVersion = this.collection.models[0];
            }
        }
    },
    renderData: function () {
        return {
            hideIssuedOn: this.options.hideIssuedOn,
            canEdit: this.options.canEdit,
            canShare: this.options.canShare,
            canDownload: this.options.canDownload,
            canOrder: this.options.canOrder,
            isPaidDownload: this.options.isPaidDownload,
            drawingCount: this.collection ? this.collection.getDrawingCount() : 0,
            versions: this.collection,
            view: this.options.view,
            mode: this.options.mode,
            search: this.options.search,
            contextVersion: this.contextVersion,
            unPublishedBatchCount: this.unPublishedBatchCount
        };
    },
    afterRender: function () {
        if (this.collection != null) {
            if (this.collection.getDrawingCount() > 0) {
                this.tagSelectPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('select.drawings-filter'),
                    defaultValue: this.filterTags,
                    noneSelectedText: 'Filter Tags',
                    isMultiple: true,
                    onChange: _.bind(function (value) {
                        this.filterTags = value;
                        this.renderContextVersion();
                    }, this)
                });
                this.renderContextVersion();
                if (this.scrollTop > 0) {
                    this.$('.version-drawings').scrollTop(this.scrollTop);
                    this.scrollTop = null;
                }
            } else if (this.collection.isFetched) {
                this.renderEmptyState();
            }
        }
    },
    refresh: function () {
        this.scrollTop = $('.version-drawings').scrollTop();
        this.render();
    },
    deleteDrawing: function (e) {
        e.stopPropagation();

        let $drawing = $(e.currentTarget).closest('.version-drawing-outer'),
            drawing = this.contextVersion.drawings.get($drawing.data('cid')),
            self = this;
        new PJQ.views.modals.DeleteVersionModal({
            onDeleteInAll: function () {
                drawing.destroy({
                    success: function () {
                        _.each(self.collection.models, function (version) {
                            let verDrawing = _.find(version.drawings.models, function (compDrawing) {
                                return drawing.get('name') === compDrawing.get('name');
                            });
                            if (verDrawing != null) {
                                verDrawing.destroy();
                                version.drawings.remove(verDrawing);
                            }
                        });
                        $drawing.parent().remove();
                    }
                });
            },
            onDeleteInThis: function () {
                drawing.destroy({
                    success: function () {
                        let curSet = self.collection.get(-1);
                        if (curSet != null) {
                            let verDrawing = _.find(curSet.drawings.models, function (compDrawing) {
                                return drawing.get('name') === compDrawing.get('name');
                            });
                            if (verDrawing != null) {
                                verDrawing.destroy();
                                curSet.drawings.remove(verDrawing);
                            }
                        }
                        $drawing.parent().remove();
                    }
                });
            }
        });
    },
    rotateBatchDrawing90Clicked: function (e) {
        e.stopPropagation();
        this.rotateDrawing(e, 90);
    },
    rotateBatchDrawing180Clicked: function (e) {
        e.stopPropagation();
        this.rotateDrawing(e, 180);
    },
    rotateBatchDrawing270Clicked: function (e) {
        e.stopPropagation();
        this.rotateDrawing(e, 270);
    },
    rotateDrawing: function (e, degrees) {
        let $drawing = $(e.currentTarget).closest('.version-drawing-outer'),
            drawing = this.contextVersion.drawings.get($drawing.data('cid')),
            rotateLoader = new PJQ.Loader($drawing);
        drawing.rotate(degrees, _.bind(function () {
            rotateLoader.remove();
            $drawing.find('.version-drawing').attr('src', drawing.thumbUrl());
            rotateLoader.remove();
        }, this));
    },
    updateTagChoices: function () {
        if (this.tagSelectPicker != null) {
            let tags = this.contextVersion.getDrawingTags().sort(PJQ.helpers.sortHelpers.sortAlphaNum);
            this.tagSelectPicker.updateChoices(tags);
        }
    },
    renderViewGrid: function () {
        this.$('.btn-view-grid').removeClass('btn-light').addClass('btn-primary');
        this.$('.btn-view-list').removeClass('btn-primary').addClass('btn-light');
        this.options.view = 'grid';
        this.renderContextVersion();
    },
    renderViewList: function () {
        this.$('.btn-view-list').removeClass('btn-light').addClass('btn-primary');
        this.$('.btn-view-grid').removeClass('btn-primary').addClass('btn-light');
        this.options.view = 'list';
        this.renderContextVersion();
    },
    saveVersion: function () {
        this.contextVersion.drawings.options.project = this.options.project;

        let valid = true;
        _.each(this.contextVersion.drawings.models, function (drawing) {
            let thisValid = null == _.find(this.contextVersion.drawings.models, function (compareDrawing) {
                return drawing.cid !== compareDrawing.cid && drawing.get('name') === compareDrawing.get('name');
            });
            valid = valid && thisValid;

            let $drawing = this.$('.version-drawing-outer[data-cid="' + drawing.cid + '"]');
            PJQ.helpers.inputHelpers.setInputError($drawing.find('.input-drawing-name'), thisValid);
        }, this);

        if (!valid) {
            if (this.duplicateNameAlert == null) {
                this.duplicateNameAlert = new PJQ.Alert(this.$('.version-drawings'), {
                    type: 'danger',
                    isBefore: true,
                    text: 'Some of the drawings have duplicated names.  Drawing names must be unique per version.',
                    extraClasses: ['alert-duplicate-name']
                });
            }
            return;
        } else if (this.duplicateNameAlert != null) {
            this.duplicateNameAlert.destroy();
            this.duplicateNameAlert = null;
        }

        this.contextVersion.drawings.save({
            put: true,
            urlOptions: {
                isFileAPI: true
            },
            success: _.bind(function () {
                _.each(this.contextVersion.drawings.models, function (contextDrawing) {
                    _.each(this.collection.models, function (version) {
                        _.each(version.drawings.models, function (otherDrawing) {
                            if (otherDrawing.get('name') === contextDrawing.get('name')) {
                                otherDrawing.set('title', contextDrawing.get('title'), {
                                    silent: true
                                });
                            }
                        });
                    });
                }, this);

                this.options.mode = PJQ.constants.drawings.dashboardModes.VIEW;
                this.render();
            }, this)
        });
    },
    bulkTag: function () {
        new PJQ.views.drawings.BulkTagModal({
            collection: this.collection,
            onClose: _.bind(function () {
                this.render();
            }, this)
        });
    },
    sortVersion: function () {
        new PJQ.views.drawings.SortDrawingsModal({
            versions: this.collection,
            sortVersion: this.contextVersion,
            sortFullSet: true,
            onDone: _.bind(function () {
                this.render();
            }, this)
        });
    },
    editVersion: function () {
        this.options.mode = PJQ.constants.drawings.dashboardModes.EDIT;
        this.render();
    },
    cancelEditVersion: function () {
        _.each(this.contextVersion.drawings.models, function (drawing) {
            drawing.restore();
        });
        this.options.mode = PJQ.constants.drawings.dashboardModes.VIEW;
        this.render();
    },
    getFilteredDrawings: function () {
        this.options.search = this.$('.input-drawings-search').val().toLowerCase();

        let result,
            isSearch = _.size(this.options.search) > 0,
            isFilterTags = _.size(this.filterTags) > 0;
        if (isSearch || isFilterTags) {
            result = [];
            _.each(this.contextVersion.drawings.models, _.bind(function (drawing) {
                if (isSearch && drawing.get('name').toLowerCase().indexOf(this.options.search) === -1 && drawing.get('title').toLowerCase().indexOf(this.options.search) === -1) {
                    return false;
                }
                if (isFilterTags && _.find(this.filterTags, function (filterTag) {
                    return _.find(drawing.get('tags'), function (drawingTag) {
                        return filterTag === drawingTag;
                    }) != null;
                }) == null) {
                    return false;
                }
                result.push(drawing);
            }, this));
        } else {
            result = this.contextVersion.drawings.models;
        }
        return result;
    },
    renderEmptyState: function () {
        this.renderSubTemplate(false, this.options.subTemplates.emptyState, this.$('.version-drawings'), {
            canEdit: this.options.canEdit
        });
    },
    renderContextVersion: function () {
        if (this.options.mode === PJQ.constants.drawings.dashboardModes.VIEW && this.contextVersion.get('issuedOn') != null) {
            this.renderVersionSelector();
        }

        this.$('.selector-version-name,.context-version-name').text(this.contextVersion.get('name'));
        this.$('.context-version-issued').text(PJQ.helpers.dateHelpers.getDateString(new Date(this.contextVersion.get('issuedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true));
        this.$('.context-version-drawing-count').text(_.size(this.contextVersion.drawings.models));
        this.updateTagChoices();
        let versionTmpl;
        if (this.options.view === 'list') {
            versionTmpl = this.options.subTemplates.versionList;
        } else {
            versionTmpl = this.options.subTemplates.versionGrid;
        }
        this.renderSubTemplate(false, versionTmpl, this.$('.version-drawings'), {
            mode: this.options.mode,
            versions: this.collection,
            canEdit: this.options.canEdit,
            drawings: this.getFilteredDrawings()
        }, _.bind(function () {
            PJQ.app.lazyLoad().update();
            this.renderSubTemplate(false, this.options.subTemplates.versionStats, this.$('.version-stats'), {
                versions: this.collection,
                contextVersion: this.contextVersion
            });
        }, this));
    },
    newBatch: function () {
        new PJQ.views.drawings.DrawingBatchModal({
            versions: this.collection,
            project: this.options.project
        });
    },
    drawingNameChanged: function (e) {
        let $target = $(e.currentTarget),
            $drawing = $target.closest('.version-drawing-outer'),
            cid = $drawing.data('cid'),
            drawing = this.contextVersion.drawings.get(cid),
            name = $target.val();
        drawing.set('name', name);
    },
    drawingTitleChanged: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.closest('.version-drawing-outer').data('cid'),
            drawing = this.contextVersion.drawings.get(cid);
        drawing.set('title', $target.val());
    },
    drawingClicked: function (e) {
        let cid = $(e.currentTarget).data('cid'),
            drawing = this.contextVersion.drawings.get(cid);

        let initViewer = _.bind(function () {
            new PJQ.views.drawings.DrawingViewer({
                model: drawing,
                project: this.options.project,
                forShare: this.options.forShare,
                isEdit: this.options.mode === PJQ.constants.drawings.dashboardModes.EDIT,
                canEdit: this.options.canEdit,
                contextVersion: this.contextVersion,
                accessKey: this.options.accessKey,
                versions: this.collection,
                onClose: _.bind(function (changed) {
                    if (changed) {
                        this.refresh();
                    }
                }, this),
                onDelete: _.bind(function () {
                    this.refresh();
                }, this)
            });
        }, this);
        if (this.options.project != null) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                initViewer();
            }, this));
        } else {
            initViewer();
        }
    },
    versionSelected: function (e) {
        let cid = $(e.currentTarget).data('cid');
        if (cid != null) {
            this.contextVersion = this.collection.get(cid);
            this.renderContextVersion();
        }
    },
    renderVersionSelector: function () {
        let $versionSelect = this.$('.drawing-versions');
        this.renderSubTemplate(false, this.options.subTemplates.versionSelect, $versionSelect, {
            versions: _.filter(this.collection.models, function (ver) {
                return _.size(ver.drawings) > 0;
            }),
            hideIssuedOn: this.options.hideIssuedOn,
            contextVersion: this.contextVersion,
            currentSet: this.collection.get(-1)
        });
    },
    manageVersions: function () {
        new PJQ.views.drawings.ManageVersionsModal({
            collection: this.collection,
            project: this.options.project,
        });
    },
    viewUploadLog: function () {
        new PJQ.views.drawings.DrawingUploadLogModal({
            project: this.options.project,
            versions: this.collection
        });
    },
    shareDrawings: function () {
        new PJQ.views.drawings.DrawingShareModal({
            collection: this.collection,
            onSave: _.bind(function (versions) {
                let shareDrawings = new PJQ.collections.drawings.Drawings(),
                    versionIds = [];

                shareDrawings.options.allDrawings = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWING_SHARE_PREVENT_EXPIRATION);

                _.each(versions, function (version) {
                    versionIds.push(version.versionId);
                    _.each(version.guids, function (guid) {
                        shareDrawings.add(new PJQ.models.drawings.Drawing({
                            guid: guid
                        }));
                    });
                });
                let sharingModal = new PJQ.views.sharing.SharingModal({
                    collection: shareDrawings,
                    subject: 'Drawings have been shared with you',
                    onSave: _.bind(function (data) {
                        shareDrawings.share(versionIds, null, data, this.options.project, _.bind(function (share) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Drawing share email sent'
                            });
                        }, this));
                    }, this)
                });
                shareDrawings.share(versionIds, null, null, this.options.project, function (share) {
                    let callback = _.bind(sharingModal.urlChanged, sharingModal);
                    callback(share.url);
                });
            }, this)
        });
    },
    downloadDrawings: function (drawings, options) {
        let download = _.bind(function () {
            PJQ.helpers.drawings.createDownload(this.options.project, [{
                versionId: this.contextVersion.id,
                guids: _.map(drawings, function (drawing) {
                    return drawing.get('guid');
                })
            }], options);
        }, this);
        if (this.options.project != null) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                download();
            }, this));
        } else {
            download();
        }
    },
    downloadContextVersionSplit: function () {
        if (this.options.isPaidDownload) {
            let entryIds = [];
            _.each(this.contextVersion.drawings.models, function (model) {
                entryIds.push(model.get('drawingId') * -1);
            });

            if (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                new PJQ.views.drawings.OrderDownloadAdmin({
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                new PJQ.views.drawings.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.DOWNLOAD,
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            }
        } else {
            this.downloadDrawings(this.contextVersion.drawings.models);
        }
    },
    downloadContextVersionMerged: function () {
        this.downloadDrawings(this.contextVersion.drawings.models, {
            merge: true
        });
    },
    downloadFilteredSplit: function () {
        if (this.options.isPaidDownload) {
            let entryIds = [];
            _.each(this.getFilteredDrawings(), function (model) {
                entryIds.push(model.get('drawingId') * -1);
            });

            if (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                new PJQ.views.drawings.OrderDownloadAdmin({
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                new PJQ.views.drawings.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.DOWNLOAD,
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            }
        } else {
            this.downloadDrawings(this.getFilteredDrawings());
        }

    },
    downloadFilteredMerged: function () {
        this.downloadDrawings(this.getFilteredDrawings(), {
            merge: true
        });
    },
    downloadAdvanced: function () {
        new PJQ.views.drawings.AdvancedDownloadModal({
            project: this.options.project,
            orderSettings: this.options.orderSettings,
            collection: this.collection,
            isPaidDownload: this.options.isPaidDownload
        });
    },
    exportDrawingList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'export'
            }
        ]));
    },
    orderContextVersion: function () {
        let entryIds = [];
        _.each(this.contextVersion.drawings.models, function (model) {
            entryIds.push(model.get('drawingId') * -1);
        });
        new PJQ.views.drawings.OrderPrintsModal({
            mode: PJQ.constants.files.modes.PRINT,
            entryIds: entryIds,
            orderSettings: this.options.orderSettings
        });

    },
    orderFiltered: function () {
        let entryIds = [];
        _.each(this.getFilteredDrawings(), function (model) {
            entryIds.push(model.get('drawingId') * -1);
        });
        if (_.size(entryIds) > 0) {
            new PJQ.views.drawings.OrderPrintsModal({
                mode: PJQ.constants.files.modes.PRINT,
                entryIds: entryIds,
                orderSettings: this.options.orderSettings
            });
        } else {
            PJQ.notifications.notify.errorNotify({
                message: 'No drawings in filter'
            });
        }

    },
    orderAdvanced: function () {
        new PJQ.views.drawings.AdvancedDownloadModal({
            project: this.options.project,
            orderSettings: this.options.orderSettings,
            collection: this.collection,
            isPaidDownload: false,
            isPrintOrder: true
        });
    }
});

PJQ.views.drawings.DrawingShareModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Drawing-Share'),
        onSave: null
    },
    defaultEvents: {
        'click .btn-cancel': 'removeModal',
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.selectedVersions = [];
    },
    afterRender: function () {
        new PJQ.views.drawings.DrawingSelectorTree({
            el: this.$('.drawings-tree'),
            collection: this.collection,
            onChange: _.bind(function (versions) {
                this.selectedVersions = versions;
            }, this)
        });
    },
    renderData: function () {
        return {
            collection: this.collection
        };
    },
    save: function () {
        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.selectedVersions);
        }
        this.removeModal();
    }
});

PJQ.views.drawings.DrawingSelectorTree = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Selector-Tree'),
        flatten: false,
        onChange: null
    },
    events: {
        'click .version-expand': 'expandVersion',
        'change .cb-version': 'versionSelected',
        'change .cb-drawing': 'drawingSelected'
    },
    beforeFirstRender: function () {
        this.selectedVersions = [];
        this.selectedDrawings = [];
        this.drawings = this.collection.getUniqueDrawings();
    },
    renderData: function () {
        return {
            versions: this.collection.models,
            drawings: this.drawings,
            flatten: this.options.flatten
        };
    },
    flatten: function (flatten) {
        this.options.flatten = flatten;
        this.render();
    },
    expandVersion: function (e) {
        let $outer = $(e.currentTarget).closest('.version-outer'),
            $drawings = $outer.find('.version-drawings');
        $drawings.toggleClass('hidden');
    },
    versionSelected: function (e) {
        let $target = $(e.currentTarget),
            $outer = $target.closest('.version-outer'),
            isSelected = $target.prop('checked'),
            versionCid = $target.data('versionCid'),
            version = this.collection.get(versionCid);

        if (isSelected) {
            let selectedVersion = _.findWhere(this.selectedVersions, {versionId: version.id});
            if (selectedVersion == null) {
                selectedVersion = {
                    versionId: version.id,
                };
            }
            selectedVersion.guids = _.map(version.drawings.models, function (drawing) {
                return drawing.get('guid');
            });
            selectedVersion.ids = _.map(version.drawings.models, function (drawing) {
                return drawing.id;
            });

            if (_.size(selectedVersion.guids) > 0 || _.size(selectedVersion.ids) > 0) {
                this.selectedVersions.push(selectedVersion);
            }
        } else {
            this.selectedVersions = _.filter(this.selectedVersions, function (deleteVersion) {
                return deleteVersion.versionId !== version.id;
            });
        }
        $outer.find('.cb-drawing').prop('checked', isSelected);
        this.onChange();
    },
    drawingSelected: function (e) {
        let $target = $(e.currentTarget),
            isSelected = $target.prop('checked'),
            drawingCid = $target.data('drawingCid');

        if (this.options.flatten) {
            let drawing = _.find(this.drawings, function (drawing) {
                return drawing.cid === drawingCid;
            });
            if (isSelected && !_.contains(this.selectedDrawings, drawing.id)) {
                this.selectedDrawings.push(drawing.id);
            } else {
                this.selectedDrawings = _.without(this.selectedDrawings, drawing.id);
            }
        } else {
            let $outer = $target.closest('.version-outer'),
                $cbVersion = $outer.find('.cb-version'),
                versionCid = $target.data('versionCid'),
                version = this.collection.get(versionCid),
                drawing = _.find(version.drawings.models, function (drawing) {
                    return drawing.cid === drawingCid;
                }),
                selectedVersion = _.findWhere(this.selectedVersions, {versionId: version.id});
            if (isSelected) {
                if (selectedVersion == null) {
                    selectedVersion = {
                        versionId: version.id,
                        guids: [drawing.get('guid')],
                        ids: [drawing.id]
                    };
                    this.selectedVersions.push(selectedVersion);
                } else {
                    selectedVersion.guids.push(drawing.get('guid'));
                    selectedVersion.ids.push(drawing.id);
                }

                if (_.size($outer.find(".cb-drawing:not(:checked)")) === 0) {
                    $cbVersion.prop('checked', true);
                }
            } else if (selectedVersion != null) {
                selectedVersion.guids = _.without(selectedVersion.guids, drawing.get('guid'));
                selectedVersion.ids = _.without(selectedVersion.ids, drawing.id);
                if (_.size(selectedVersion.guids) === 0) {
                    this.selectedVersions = _.filter(this.selectedVersions, function (deleteVersion) {
                        return deleteVersion.versionId !== version.id;
                    });
                }

                $cbVersion.prop('checked', false);
            }
        }

        this.onChange();
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.options.flatten ? this.selectedDrawings : this.selectedVersions);
        }
    }
});

PJQ.views.modals.DeleteVersionModal = PJQ.views.BaseModal.extend({
    defaults: {
        header: "Confirm Delete",
        body: "Where would you like to delete this drawing from?"
    },
    beforeModalCreated: function () {
        this.options = _.defaults({
            isShowOkButton: true,
            okButtonText: 'All Versions',
            okButtonColorClass: 'danger',
            onOk: _.bind(function () {
                if (typeof this.options.onDeleteInAll === 'function') {
                    this.options.onDeleteInAll();
                }
            }, this),
            isShowSecondaryButton: true,
            secondaryButtonColorClass: 'outline-danger',
            secondaryButtonText: 'This Version',
            onSecondary: _.bind(function () {
                if (typeof this.options.onDeleteInThis === 'function') {
                    this.options.onDeleteInThis();
                }
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "Cancel",
            onClose: _.bind(function () {
                if (typeof this.options.onCancel === 'function') {
                    this.options.onCancel();
                }
            }, this)
        }, this.options);
    }
});

PJQ.views.drawings.BulkTagModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Bulk-Tag'),
        subTemplates: {
            drawingTags: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Tags'),
        },
        onClose: null
    },
    defaultEvents: {
        'change .cb-specify-version': 'renderDrawingSelector',
        'click .btn-add-tag': 'addTag',
        'click .btn-delete-tag': 'deleteTag',
        'keyup .input-tag': 'tagChanged',
        'click .btn-close': 'close'
    },
    afterRender: function () {
        this.renderDrawingSelector();
        this.renderExistingTags();
    },
    renderDrawingSelector: function () {
        this.selectedVersions = [];
        this.selectedDrawings = [];
        let flatten = !this.$('.cb-specify-version').prop('checked');
        if (this.drawingSelector == null) {
            this.drawingSelector = new PJQ.views.drawings.DrawingSelectorTree({
                el: this.$('.drawings-tree'),
                flatten: !this.$('.cb-specify-version').prop('checked'),
                collection: this.collection,
                onChange: _.bind(function (data) {
                    if (!this.$('.cb-specify-version').prop('checked')) {
                        this.selectedDrawings = data;
                    } else {
                        this.selectedVersions = data;
                    }
                    this.renderExistingTags();
                    this.validateTag();
                }, this)
            });
        } else {
            this.drawingSelector.flatten(flatten);
        }
    },
    tagChanged: function (e) {
        if (e.keyCode === 13) {
            this.addTag();
            return;
        }

        this.validateTag();
    },
    validateTag: function () {
        let tag = this.$('.input-tag').val();
        this.$('.btn-add-tag').prop('disabled', _.size(this.getSelectedDrawingIds()) === 0 || _.size(tag) === 0);
    },
    getInputTags: function () {
        let tagString = $('.input-tag').val(),
            tags = [];
        if (_.size(tagString) > 0) {
            _.each(tagString.split(','), function (tag) {
                let tagTrim = tag.trim();
                if (_.size(tagTrim) > 0) {
                    tags.push(tagTrim);
                }
            });
        }
        return tags;
    },
    getSelectedDrawingIds: function () {
        let drawingIds = [];
        _.each(this.selectedVersions, function (version) {
            drawingIds.push(...version.ids);
        });
        drawingIds.push(...this.selectedDrawings);
        return drawingIds;
    },
    endpoint: function (allVersions = false, isDelete = false) {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'tags'
            }
        ], [
            {
                parameter: 'delete',
                value: isDelete
            },
            {
                parameter: 'allVersions',
                value: allVersions
            }
        ]);
    },
    renderExistingTags: function () {
        let tags = [];
        if (_.size(this.selectedVersions) > 0) {
            _.each(this.selectedVersions, _.bind(function (version) {
                let mVer = this.collection.get(version.versionId);
                _.each(version.ids, function (drawingId) {
                    let mDr = mVer.drawings.get(drawingId);
                    _.each(mDr.get('tags'), function (tag) {
                        if (!_.contains(tags, tag)) {
                            tags.push(tag);
                        }
                    });
                });
            }, this));
        }

        if (_.size(this.selectedDrawings) > 0) {
            _.each(this.selectedDrawings, _.bind(function (drawingId) {
                _.each(this.collection.models, function (version) {
                    let mDr = version.drawings.get(drawingId);
                    if (mDr != null) {
                        _.each(mDr.get('tags'), function (tag) {
                            if (!_.contains(tags, tag)) {
                                tags.push(tag);
                            }
                        });
                    }
                });
            }, this));
        }
        this.renderSubTemplate(false, this.options.subTemplates.drawingTags, this.$('.drawing-tags'), {
            tags: tags
        });
    },
    addTag: function () {
        let allVersions = !this.$('.cb-specify-version').prop('checked'),
            tags = this.getInputTags();
        new PJQ.ajax.Request({
            endpoint: this.endpoint(allVersions),
            data: {
                drawingIds: this.getSelectedDrawingIds(),
                tags: tags
            }
        }).post().done(_.bind(function () {
            this.clearTagInput();
            this.alterTags(tags);
            this.renderExistingTags();
        }, this)).fail(function () {
            this.error();
        });
    },
    deleteTag: function (e) {
        let allVersions = !this.$('.cb-specify-version').prop('checked'),
            tag = $(e.currentTarget).closest('.drawing-tag').data('name');
        new PJQ.ajax.Request({
            endpoint: this.endpoint(allVersions, true),
            data: {
                drawingIds: this.getSelectedDrawingIds(),
                tags: [tag]
            }
        }).post().done(_.bind(function (data) {
            this.clearTagInput();
            this.alterTags(tag, true);
            this.renderExistingTags();
        }, this)).fail(function () {
            this.error()
        });
    },
    alterTags: function (tags, isDelete = false) {
        if (_.size(this.selectedVersions) > 0) {
            _.each(this.selectedVersions, _.bind(function (version) {
                let mVer = this.collection.get(version.versionId);
                _.each(version.ids, function (drawingId) {
                    let mDr = mVer.drawings.get(drawingId);
                    if (isDelete) {
                        mDr.deleteTag(tags, {
                            save: false
                        });
                    } else {
                        mDr.addTags(tags, {
                            save: false
                        });
                    }
                });
            }, this));
        }

        if (_.size(this.selectedDrawings) > 0) {
            _.each(this.selectedDrawings, _.bind(function (drawingId) {
                _.each(this.collection.models, function (version) {
                    let mDr = version.drawings.get(drawingId);
                    if (mDr != null) {
                        if (isDelete) {
                            mDr.deleteTag(tags, {
                                save: false
                            });
                        } else {
                            mDr.addTags(tags, {
                                save: false
                            });
                        }
                    }
                });
            }, this));
        }
    },
    clearTagInput: function () {
        this.$('.input-tag').val('');
        this.validateTag();
    },
    error: function () {

    },
    close: function () {
        this.removeModal();
        if (typeof this.options.onClose === 'function') {
            this.options.onClose();
        }
    }
});
